import { newE2EPage } from '@stencil/core/testing';

describe('jackery-skeleton', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-skeleton></jackery-skeleton>');

    const element = await page.find('jackery-skeleton');
    expect(element).toHaveClass('hydrated');
  });
});
